import { styles as componentStyles } from './view.scss';
import { styles as styleHelpersStyles } from '../../../assets/style-helpers.scss';
import { unsafeCSS } from 'lit';

export const styles = [unsafeCSS(`${componentStyles}`), unsafeCSS(`${styleHelpersStyles}`)];
